import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

interface PagerSkeletonProps {
  className?: string;
  loaderClassName?: string;
}

const COUNTER_HEIGHT = 20;
const COUNTER_WIDTH = 30;

export default function PagerSkeleton({
  className = "",
  loaderClassName = "display-block",
}: Readonly<PagerSkeletonProps>) {
  return (
    <div className={`display-flex justify-content-center ${className}`.trim()}>
      <div className="display-flex flex-column min-width-150">
        <div className="display-flex align-items-center justify-content-center gap-10 margin-bottom-10">
          <span className="rioglyph rioglyph-chevron-left text-color-light text-size-14" aria-hidden="true" />
          <ContentLoader className={loaderClassName} height={COUNTER_HEIGHT} width={COUNTER_WIDTH} />
          <span className="rioglyph rioglyph-chevron-right text-color-light text-size-14" aria-hidden="true" />
        </div>
        <div className="progress height-3" />
      </div>
    </div>
  );
}
